// =============================================================================
// Endpoints
// -- Neste ficheiro irá constar uma lista dos enpoints da API por página de frontend.
// =============================================================================
export default {
    campaigns: {
        crud: 'campaigns'
    },
    reporting: {
        crud: null
    },
    users: {
        crud: 'users'
    },
    clients: {
        crud: 'clients'
    },
    audit: {
        crud: 'contacts'
    },
    token: {
        crud: 'clients/personal-access-token'
    }
};